exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blockAbove {\n  height:100px;\n  background-color: #f8fff8;\n}\n.ontologies-page {\n  margin-top: 30px;\n  text-align: justify;\n}\n.ontologies-page.description {\n  margin: 10px 0 25px;\n  text-align: justify;\n}\n.ontology-list {\n  list-style-type: none;\n  font-weight: bold;\n}\n.ontology-title {\n  color:#31b34a;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fc131acc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RootPane.vue
// module id = YrlQ
// module chunks = 1